import React from 'react';

const posts = [
  {
    slug: 'herbal-remedies-nigerian-women',
    tag: 'Wellness', date: 'July 2026',
    bg: 'linear-gradient(135deg, #1E8449, #27AE60)',
    icon: '🌿',
    title: '5 Herbal Remedies That Actually Work for Nigerian Women',
    excerpt: 'Nature has always had the answers. Here are 5 herbal solutions that have transformed the health of thousands across Nigeria — backed by centuries of tradition and modern results.',
    readTime: '4 min read',
  },
  {
    slug: 'multiple-income-streams-from-zero',
    tag: 'Business', date: 'July 2026',
    bg: 'linear-gradient(135deg, #C9973A, #E8B84B)',
    icon: '💰',
    title: 'How to Build Multiple Income Streams Starting from Zero',
    excerpt: 'You do not need millions to start. You need a plan, the right mentor, and the courage to begin. Here is exactly how I built my first income stream with nothing but my phone and a WhatsApp group.',
    readTime: '6 min read',
  },
  {
    slug: 'real-estate-smartest-investment-nigeria',
    tag: 'Real Estate', date: 'July 2026',
    bg: 'linear-gradient(135deg, #2471A3, #3498DB)',
    icon: '🏠',
    title: 'Why Real Estate is Still the Smartest Investment in Nigeria',
    excerpt: 'Despite economic uncertainty, property remains one of the most reliable ways to grow and protect your wealth in Nigeria. Here is what the smart money is doing right now.',
    readTime: '5 min read',
  },
  {
    slug: 'network-marketing-truth-nigeria',
    tag: 'MLM Coaching', date: 'July 2026',
    bg: 'linear-gradient(135deg, #6C3483, #8E44AD)',
    icon: '🤝',
    title: 'The Truth About Network Marketing Nobody Tells You',
    excerpt: 'Most people fail at network marketing not because the industry is bad — but because nobody taught them the right way to build a team. Here is what I wish someone had told me on day one.',
    readTime: '7 min read',
  },
  {
    slug: 'digital-marketing-small-business-nigeria',
    tag: 'Digital Marketing', date: 'July 2026',
    bg: 'linear-gradient(135deg, #1E8449, #3498DB)',
    icon: '📱',
    title: 'How Small Businesses in Nigeria Can Win Online in 2026',
    excerpt: 'The digital space in Nigeria is booming. But most small businesses are still missing out. Here are the exact strategies that are working right now for entrepreneurs like you.',
    readTime: '5 min read',
  },
  {
    slug: 'wellness-morning-routine',
    tag: 'Wellness', date: 'July 2026',
    bg: 'linear-gradient(135deg, #27AE60, #C9973A)',
    icon: '☀️',
    title: 'The Morning Routine That Changed My Life and Business',
    excerpt: 'I used to wake up and immediately check my phone. Now I wake up and own my morning. This simple shift transformed not just my health — but my income too.',
    readTime: '4 min read',
  },
];

export default function BlogPage() {
  return (
    <div style={{ paddingTop: '80px', background: '#FAFAF8', minHeight: '100vh' }}>

      {/* Blog Hero */}
      <div style={{
        background: 'linear-gradient(135deg, #1A5C38 0%, #1E8449 100%)',
        padding: 'clamp(60px, 8vw, 100px) clamp(20px, 4vw, 52px)',
        textAlign: 'center', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: '-60px', right: '-60px',
          width: '300px', height: '300px', borderRadius: '50%',
          background: 'rgba(201,151,58,0.1)',
        }} />
        <span style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: '11px', fontWeight: 600, letterSpacing: '4px',
          textTransform: 'uppercase', color: '#C9973A',
          marginBottom: '16px', display: 'block',
        }}>Insights & Stories</span>
        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 'clamp(32px, 6vw, 64px)', fontWeight: 900,
          color: '#fff', lineHeight: 1.1, marginBottom: '16px',
        }}>
          The <em style={{ color: '#C9973A', fontStyle: 'italic' }}>Blog</em>
        </h1>
        <p style={{
          fontSize: 'clamp(15px, 2vw, 18px)', color: 'rgba(255,255,255,0.8)',
          maxWidth: '560px', margin: '0 auto', lineHeight: 1.7,
        }}>
          Tips, stories, and strategies on wellness, business, real estate, and building the life you deserve.
        </p>
      </div>

      {/* Blog Grid */}
      <div style={{
        maxWidth: '1160px', margin: '0 auto',
        padding: 'clamp(40px, 6vw, 80px) clamp(20px, 4vw, 52px)',
      }}>
        {/* Featured Post */}
        <div style={{ marginBottom: '48px' }}>
          <span style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '11px', fontWeight: 600, letterSpacing: '3px',
            textTransform: 'uppercase', color: '#1E8449', marginBottom: '24px',
            display: 'block',
          }}>Featured Post</span>
          <a href={`/blog/${posts[0].slug}`} style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '0', textDecoration: 'none', color: '#1A1A1A',
            background: '#fff', borderRadius: '12px', overflow: 'hidden',
            border: '1px solid #E0EDE6',
            transition: 'box-shadow 0.3s',
          }}
          onMouseEnter={e => e.currentTarget.style.boxShadow = '0 20px 48px rgba(0,0,0,0.1)'}
          onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
          >
            <div style={{
              background: posts[0].bg, minHeight: '280px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '80px',
            }}>
              {posts[0].icon}
            </div>
            <div style={{ padding: '40px 36px' }}>
              <span style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '10px', fontWeight: 700, letterSpacing: '2px',
                textTransform: 'uppercase', color: '#1E8449',
                marginBottom: '12px', display: 'block',
              }}>{posts[0].tag} · {posts[0].readTime}</span>
              <h2 style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: 'clamp(22px, 3vw, 32px)', fontWeight: 700,
                lineHeight: 1.2, marginBottom: '16px',
              }}>{posts[0].title}</h2>
              <p style={{
                fontSize: '15px', lineHeight: 1.75, color: '#555550',
                marginBottom: '24px',
              }}>{posts[0].excerpt}</p>
              <div style={{
                fontFamily: "'Inter', sans-serif",
                fontSize: '11px', fontWeight: 700, letterSpacing: '2px',
                textTransform: 'uppercase', color: '#1E8449',
                display: 'flex', alignItems: 'center', gap: '8px',
              }}>Read Article →</div>
            </div>
          </a>
        </div>

        {/* All Posts Grid */}
        <span style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: '11px', fontWeight: 600, letterSpacing: '3px',
          textTransform: 'uppercase', color: '#1E8449', marginBottom: '24px',
          display: 'block',
        }}>All Posts</span>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '28px',
        }}>
          {posts.slice(1).map(post => (
            <a key={post.slug} href={`/blog/${post.slug}`} style={{
              background: '#fff', borderRadius: '12px', overflow: 'hidden',
              textDecoration: 'none', color: '#1A1A1A',
              border: '1px solid #E0EDE6', display: 'flex', flexDirection: 'column',
              transition: 'transform 0.3s, box-shadow 0.3s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-6px)';
              e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
            >
              <div style={{
                height: '180px', background: post.bg,
                display: 'flex', alignItems: 'center',
                justifyContent: 'center', fontSize: '52px',
              }}>{post.icon}</div>
              <div style={{ padding: '24px', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <span style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '10px', fontWeight: 700, letterSpacing: '2px',
                  textTransform: 'uppercase', color: '#1E8449',
                  marginBottom: '8px', display: 'block',
                }}>{post.tag} · {post.readTime}</span>
                <h3 style={{
                  fontFamily: "'Playfair Display', serif",
                  fontSize: '18px', fontWeight: 700,
                  lineHeight: 1.3, marginBottom: '10px', flexGrow: 1,
                }}>{post.title}</h3>
                <p style={{
                  fontSize: '13px', lineHeight: 1.65,
                  color: '#555550', marginBottom: '16px',
                }}>{post.excerpt.substring(0, 100)}...</p>
                <div style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: '11px', fontWeight: 700, letterSpacing: '2px',
                  textTransform: 'uppercase', color: '#1E8449',
                  borderTop: '1px solid #E0EDE6', paddingTop: '14px',
                }}>Read More →</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
